import { render, staticRenderFns } from "./TopSpacePeople.vue?vue&type=template&id=3e1e90cb"
import script from "./TopSpacePeople.vue?vue&type=script&lang=js"
export * from "./TopSpacePeople.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports